function unformatRUTValida(rut: HTMLInputElement) {
  rut.value = rut.value.toUpperCase().replace(/[\^\\w\\s]/gi, "");
}

// Obtiene el DV de un RUT
function testDv(T: number): string {
  let M = 0, S = 1;
  for (; T; T = Math.floor(T / 10)) {
    S = (S + (T % 10) * (9 - M++ % 6)) % 11;
  }
  return S ? (S - 1).toString() : 'K';
}

// Presenta un mensaje cuando el RUT es invalido
export function validaRut(rut: HTMLInputElement): boolean {
  if (rut !== undefined) {
    unformatRUTValida(rut);
    const text = rut.value.toString();
    const num = text.substring(0, text.length - 1);
    const dv = text.substring(text.length - 1);
    if (dv === testDv(parseInt(num))) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

// --------------------------------- Private OLB/IOL --------------------------------------
// Cross-browser support
function trim(rut: HTMLInputElement) {
  let tmp = rut.value.toString().toUpperCase();
  // Remove no number bigger than '0' at the left side
  while (tmp.length > 0 && (tmp.charAt(0) < '1' || tmp.charAt(0) > '9')) {
    tmp = tmp.substring(1, tmp.length);
  }
  // Remove no number (not 'K') a the rigth side
  let newvalue = "";
  for (let i = 0; i < tmp.length; i++) {
    const c = tmp.charAt(i);
    if ((c < '0' || c > '9') && c !== 'K') continue;
    newvalue = newvalue + c;
  }
  rut.value = newvalue;
}

function validarSiNumero(numero: string): boolean {
  numero = numero.replace(/\\s/g, '');
  if (/^([\0-9])*$/.test(numero)) return true;
  else return false;
}

export function formatRUT(in_rut: string): string | undefined {
  if (in_rut !== undefined) {
    const rut = { value: in_rut };
    trim(rut as HTMLInputElement);
    const text = rut.value.toString();
    if (text !== "") {
      const num = text.substring(0, text.length - 1);
      const dv = text.substring(text.length - 1);
      if (validarSiNumero(num)) {
        validaRut(rut as HTMLInputElement);
        rut.value = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '-' + dv;
        return rut.value;
      } else {
        return rut.value.toLowerCase();
      }
    }
  }
  return undefined;
}